const domainWhiteList = [
  'pstatp.com',
  'byteimg.com',
  'toutiaoimg.com',
  'bytexservice.com',
]

const domainBlackList = ['qlogo.cn', '58cdn.com.cn']

let domainList = [
  'sf1-ttcdn-tos.pstatp.com',
  'sf3-ttcdn-tos.pstatp.com',
  'sf6-ttcdn-tos.pstatp.com',
]
/**
 * 增加域名白名单
 * @param list
 */
export function addDomainWhiteList(list: string[]) {
  domainWhiteList.push(...list)
}
/**
 * 获取域名白名单
 */
export function getDomainWhiteList() {
  return domainWhiteList
}
/**
 * 增加域名黑名单
 * @param list
 */
export function addDomainBlackList(list: string[]) {
  domainBlackList.push(...list)
}
/**
 * 获取域名黑名单
 */
export function getDomainBlackList() {
  return domainBlackList
}

export function setDomainList(list: string[]) {
  domainList = list
}
export function getDomainList() {
  return domainList
}
